import React, { useRef, useEffect, useState } from "react";
import "../styles/styles.css";
import MenuItem from "../newcomponents/optioncomponents/MenuItem";
import { VariableSizeGrid as Grid } from "react-window";
import { UserContext } from "../contexts/Context";
import { navigate } from '@reach/router';
import { SwitchTransition, CSSTransition } from "react-transition-group";


const MenuItemSelectionGrid = ({
  height,
  width,
  selectedCategory,
  setSelectedMenu,
  setSelectedCategory,
  theme,
  selectedItems,
  addItemDirect,
  cart,
  removeFromCart,
  sidebarWidth,
  headerHeight,
  cp,
  menuSelectionFormRef,
  promos,
  setScrollDown,
  isScrolling
}) => {
  const scrollPos = useRef(0);
  const scrolling = useRef(false);
  const { displayMenuDescription, lanIndex, isLanReverse } = React.useContext(UserContext);
  const [heightList, setHeightList] = useState([]);
  const measuredCardHeights = useRef({});
  const usesSize3Layout = selectedCategory.type.some((item) => item && item.size == 3);
  const columnCount = usesSize3Layout ? (width >= 768 ? 2 : 1) : (width >= 768 ? 3 : (Number(cp) === 0 ? 1 : 2));
  const menuContentWidth = width - sidebarWidth;
  const hasMobileSidebar = width < 768 && Number(cp) === 0;
  const desktopCardGap = Math.max(18, Math.min(34, Math.round(menuContentWidth * 0.025)));
  // Reserve the card margins while keeping the sidebar layout compact.
  const cardInset = width >= 768 ? desktopCardGap + 16 : (hasMobileSidebar ? 14 : 18);
  const cardVerticalSpace = width >= 768 ? desktopCardGap + 16 : (hasMobileSidebar ? 14 : 18);

  //Clone of Array for Form Submission

  const ref = React.useRef();

  useEffect(() => {
    scrolling.current = isScrolling;
  }, [isScrolling]);
  useEffect(() => {
    document.getElementById("menu_scroll").addEventListener('scroll', onscroll);
    return () => {
      if (document.getElementById("menu_scroll") != null) {
        document.getElementById("menu_scroll").removeEventListener('scroll', onscroll);
      }
    }
  }, []);
  const onscroll = (e) => {
    let firstMenu = document.getElementById("menu_scroll");
    if (firstMenu == null) return;

    let pos = firstMenu.getBoundingClientRect().top;
    let offset = pos - scrollPos.current;
    if (Math.abs(offset) < 160) return;
    scrollPos.current = pos;
    if (offset < 0) {//swipe up
      setScrollDown(true);
    } else { //swipe down
      setScrollDown(false);
    }
  }

  const updateListDimension = () => {
    measuredCardHeights.current = {};

    let menuWidth = menuContentWidth;
    const columnWidth = menuWidth / columnCount;
    const showDescription = displayMenuDescription === true || displayMenuDescription === "true";
    const hasDisplayedDescription = (menuItem) => {
      if (!menuItem || menuItem.isCategory) return false;
      const description = (lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse)
        ? menuItem.description
        : (menuItem.description2 || menuItem.description);
      return typeof description === "string" && description.trim().length > 0;
    };
    let list = [];
    selectedCategory.type.forEach((lt, index) => {
      const itemSize = width >= 768 && Number(lt.size) === 1 ? 0 : Number(lt.size || 0);
      const rowIndex = parseInt(index / columnCount);
      const rowStart = rowIndex * columnCount;
      const rowItems = selectedCategory.type.slice(rowStart, rowStart + columnCount);
      const rowHasDescription = showDescription && rowItems.some(hasDisplayedDescription);
      const standardContentHeight = width >= 768
        ? (rowHasDescription ? 178 : 136)
        : (rowHasDescription ? (hasMobileSidebar ? 160 : 204) : (hasMobileSidebar ? 104 : 150));
      let itemHeight = columnWidth - cardInset + standardContentHeight + cardVerticalSpace;
      if (itemSize === 1) {
        if (width < 768 && hasMobileSidebar && !showDescription) {
          const cardWidth = menuWidth - cardInset;
          const imageHeight = cardWidth * 4 / 5;
          const compactContentHeight = 76;
          itemHeight = imageHeight + compactContentHeight + cardVerticalSpace;
        } else {
          itemHeight = menuWidth + 60;
        }
      }
      if (hasMobileSidebar && (itemSize === 0 || itemSize === 1)) {
        itemHeight = (showDescription ? 140 : 132) + cardVerticalSpace;
      }
      if (itemSize === 2) itemHeight = 96;
      if (itemSize === 3) itemHeight = (rowHasDescription ? (width >= 768 ? 176 : 172) : (width >= 768 ? 140 : 132)) + cardVerticalSpace;
      list[rowIndex] = Math.max(list[rowIndex] || 0, itemHeight);

    });
    setHeightList(list);

    if (ref.current) {
      ref.current.resetAfterIndices({
        columnIndex: 0,
        rowIndex: 0,
        shouldForceUpdate: true
      });
    }
  }

  useEffect(() => {
    updateListDimension();
  }, [selectedCategory.type, width, menuContentWidth, columnCount, cardInset, cardVerticalSpace, displayMenuDescription, lanIndex, isLanReverse, hasMobileSidebar]);

  const onCardResize = React.useCallback((itemIndex, rowIndex, cardHeight) => {
    if (measuredCardHeights.current[itemIndex] === cardHeight) return;
    measuredCardHeights.current[itemIndex] = cardHeight;
    setHeightList(previous => {
      const rowItems = selectedCategory.type.slice(rowIndex * columnCount, (rowIndex + 1) * columnCount);
      const measuredHeight = Math.max(...rowItems.map((item, offset) =>
        (Number(item.size) === 2 || Number(item.size) === 3)
          ? (measuredCardHeights.current[rowIndex * columnCount + offset] || 0) + cardVerticalSpace
          : previous[rowIndex] || 0
      ));
      if (previous[rowIndex] === measuredHeight) return previous;
      const next = [...previous];
      next[rowIndex] = measuredHeight;
      return next;
    });
    if (ref.current) ref.current.resetAfterIndices({ rowIndex, columnIndex: 0, shouldForceUpdate: true });
  }, [selectedCategory.type, columnCount, cardVerticalSpace]);

  //List Required Constants

  return (

    <SwitchTransition>
      <CSSTransition
        key={selectedCategory.category}
        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
        classNames='fade'
      >
        <Grid
          ref={ref}
          className="no-scrollbars"
          columnCount={columnCount}
          columnWidth={index => (width - sidebarWidth) / columnCount}
          height={height - headerHeight}
          rowCount={Math.ceil(selectedCategory.type.length / columnCount)}
          rowHeight={index => {
            return heightList[index] ? heightList[index] : 160 + 16
          }}
          width={width - sidebarWidth}
          itemData={{
            item: selectedCategory.type,
            setSelectedMenu: setSelectedMenu,
            setSelectedCategory: setSelectedCategory,
            theme: theme,
            selectedItems,
            addItemDirect,
            cart,
            removeFromCart,
            cp,
            menuSelectionFormRef,
            promos,
            columnCount,
            cardInset,
            cardVerticalSpace,
            onCardResize,
            isDesktop: width >= 768
          }}
        >
          {Cell}
        </Grid>
      </CSSTransition>
    </SwitchTransition>
  );
};
export default React.memo(MenuItemSelectionGrid);

const Cell = ({ columnIndex, rowIndex, data, style }) => {
  //Data passed as props to List Component
  const { item, setSelectedMenu, setSelectedCategory, theme, selectedItems, addItemDirect,
    cart, removeFromCart, cp, menuSelectionFormRef, promos, columnCount, cardInset, cardVerticalSpace, isDesktop, onCardResize } = data;
  const { lanIndex, currencySymbol, isLanReverse } = React.useContext(UserContext);
  const itemIndex = columnIndex + rowIndex * columnCount;
  const cellItem = item[itemIndex];
  const cellSize = cellItem && isDesktop && Number(cellItem.size) === 1 ? 0 : Number((cellItem && cellItem.size) || 0);
  const cellRef = useRef(null);
  useEffect(() => {
    if ((cellSize !== 2 && cellSize !== 3) || !cellRef.current || !cellRef.current.firstElementChild) return;
    const card = cellRef.current.firstElementChild;
    const measure = () => onCardResize(itemIndex, rowIndex, Math.ceil(card.getBoundingClientRect().height));
    measure();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(measure);
    observer.observe(card);
    return () => observer.disconnect();
  }, [cellSize, cellItem, itemIndex, rowIndex, onCardResize]);
  const handleSelect = () => {
    let it = cellItem;
    if (!it.isCategory) {
      //To Determine if has options
      //selectedMenu.optionArray 
      if (addItemDirect && (!it.optionArray || it.optionArray.length == 0)) {
        it.qty = 1;
        setSelectedMenu(it);
        menuSelectionFormRef.current = JSON.parse(JSON.stringify(it));

      } else {
        setSelectedMenu(it);
        menuSelectionFormRef.current = JSON.parse(JSON.stringify(it));
      }
    } else {
      setSelectedCategory(it);
      navigate('/menu/menu/' + it.category);
    }
  };


  const minusQty = (e) => {
    e.stopPropagation();
    let it = cellItem;
    //remove the latest one
    let newCart = JSON.parse(JSON.stringify(cart));
    for (let i = newCart.length - 1; i >= 0; i--) {
      if (newCart[i].codeId == it.codeId) {
        newCart[i].qty--;
        let minQty = newCart[i].minQty ? newCart[i].minQty - 1 : 0;
        if (newCart[i].qty <= minQty) {
          newCart.splice(i, 1);
        }
        localStorage.setItem("order", JSON.stringify(newCart));
        removeFromCart(newCart, i);
        break;
      }
    }

  }

  return (
    <div ref={cellRef} style={{
      ...style,
      display: cellItem && cellItem.hideDisplay ? "none" : "flex",
      justifyContent: cellItem && (cellSize === 1 || cellSize === 2 || cellSize === 3) ? "flex-start" : "center",
      alignItems: "flex-start"
    }}>
      {cellItem ? (
        <MenuItem
          key={"" + columnIndex + (rowIndex * columnCount)}
          item={cellItem}
          containerWidth={cellSize === 1 || cellSize === 2 ? (style.width * columnCount) - cardInset : style.width - cardInset}
          containerHeight={style.height - cardVerticalSpace}
          handleOnClick={handleSelect}
          addQty={handleSelect}
          minusQty={minusQty}
          theme={theme}
          lanIndex={lanIndex}
          isLanReverse={isLanReverse}
          selectedItems={selectedItems}
          currencySymbol={currencySymbol}
          addItemDirect={addItemDirect}
          cp={cp}
          promos={promos}
          menuListCard
        />
      ) : (
        <React.Fragment />
      )}
    </div>
  );
};
